import { render } from "./AppointmentStatusForm.vue?vue&type=template&id=7f247033&scoped=true"
import script from "./AppointmentStatusForm.vue?vue&type=script&lang=js"
export * from "./AppointmentStatusForm.vue?vue&type=script&lang=js"

import "./AppointmentStatusForm.vue?vue&type=style&index=0&id=7f247033&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f247033"]])

export default __exports__